import React, { Component } from 'react'
import { Row } from 'reactstrap'
// import { AnimateOnChange } from 'react-animation'
import './about.css'
import CategoryObj from '../../utils/categoria'
const cat = new CategoryObj()

export default class About extends Component {
    constructor(props) {
        super(props)
        this.state = {
            text: '',
            elementos: [],
            indice: 0,
            categorias: []
        }
    }
    componentWillMount() {
        const _this = this
        this.setState({
            text: this.state.elementos[0],
            indice: 0
        })
        cat.getCategorias().then(categorias => {
            _this.setState({
                categorias
            })
            // categorias.forEach((element, index) => {
            //     if (index === 0) {
            //         _this.setState({
            //             text: element.data().Detalle
            //         })
            //     }
            //     elementos.push(element.data().Detalle)
            // })
            // _this.setState({
            //     elementos
            // })
        })
    }

    // componentDidMount() {
    //     this.interval = setInterval(() => {
    //         const { indice, elementos } = this.state
    //         this.setState({
    //             text: elementos[indice],
    //             indice: (elementos.length - 1) == indice ? 0 : indice + 1
    //         })
    //     }, 5000);
    // }
    // componentWillUnmount() {
    //     clearInterval(this.interval);
    // }

    render() {
        return (
            <div className="about">
                <Row>
                    <h3 className="aboutTitle">Acerca de nosotros</h3>
                    <p>
                        MAPFRE se define como LA ASEGURADORA GLOBAL DE CONFIANZA, un concepto que se refiere tanto a la presencia geográfica como al amplio rango de productos aseguradores, reaseguradores y de servicios que desarrolla en todo el mundo.
                    </p>
                    <p>
                        MAPFRE aspira a liderar los mercados en los que opera, a través de un modelo de gestión propio y diferenciado basado en el crecimiento rentable, con una clara y decidida orientación al cliente, tanto particular como empresarial, con enfoque multicanal y una profunda vocación de servicio.
                    </p>
                </Row>
                <Row>
                    {
                        this.state.categorias.map(cat => <p key={cat.id}>{cat.data().Detalle}</p>)
                    }
                </Row>
                {/* <Row>
                    <Col>
                        <AnimateOnChange
                            animationIn="bounceIn"
                            animationOut="bounceOut"
                            durationOut={500}
                        >
                            {this.state.text}
                        </AnimateOnChange>
                    </Col>
                </Row> */}

            </div>
        )
    }
}